import ErrorBoundary from '@/components/ErrorBoundary'
import FormPersistenceRestoreDialog from '@/components/FormPersistence'
import { TourProvider } from '@/components/TourProvider'
import WhatsNewModal from '@/components/WhatsNew'
import { ConfirmationProvider } from '@/contexts/confirmation'
import FilePreviewContextProvider from '@/contexts/file-preview'
import { FormPersistenceProvider } from '@/contexts/form-persistence'
import { ModalProvider } from '@/contexts/modal'
import { QuickHelpProvider } from '@/contexts/quick-help'
import { RegulationsProvider } from '@/contexts/regulations'
import { TourHandlerProvider } from '@/contexts/tour-handler'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Outlet } from 'react-router-dom'
import MainLayout from '../MainLayout'
import ProtectedLayout from '../ProtechedLayout'
import Watermark from '@/components/Watermark'

const RootLayout = () => {
    return (
        <ErrorBoundary>
            <Watermark />
            <TooltipProvider>
                <TourProvider>
                    <TourHandlerProvider>
                        <QuickHelpProvider>
                            <ConfirmationProvider>
                                <FilePreviewContextProvider>
                                    <FormPersistenceProvider>
                                        <ModalProvider>
                                            <ProtectedLayout>
                                                <RegulationsProvider>
                                                    <MainLayout>
                                                        <FormPersistenceRestoreDialog />
                                                        <WhatsNewModal />
                                                        <Outlet />
                                                    </MainLayout>
                                                </RegulationsProvider>
                                            </ProtectedLayout>
                                        </ModalProvider>
                                    </FormPersistenceProvider>
                                </FilePreviewContextProvider>
                            </ConfirmationProvider>
                        </QuickHelpProvider>
                    </TourHandlerProvider>
                </TourProvider>
            </TooltipProvider>
        </ErrorBoundary>
    )
}

export default RootLayout
